/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SchoolBell-E API
 * SchoolBell 레거시 플랫폼 리소스 OAuth AS + RS
 * OpenAPI spec version: 1.0
 */

/**
 * 좌석의 role(Owner/Admin/Member).
 */
export type MemberRole = typeof MemberRole[keyof typeof MemberRole];


export const MemberRole = {
  Owner: 'Owner',
  Admin: 'Admin',
  Member: 'Member',
} as const;
